import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Grid,
} from "@mui/material";
import HeaderBar from '../HeaderBar/HeaderBar';
import { signIn } from '../../api/authService';
import { useAuth } from '../../hooks/useAuth';
import { useUser } from '../../context/UserContext';
import { verifyOTP, verifyNewMemberOTP } from '../../api/authService';

const ValidateOTP = () => {
  const [code, setCode] = useState(""); // Stores the user's entered OTP
  const {user, updateUser} = useUser();
  const [email, setEmail] = useState(user.email); // Stores the user's email
  //const [email, setEmail] = useState("madhu_vadduri@yahoo.com"); // Stores the user's email
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { signIn } = useAuth();
  const [data, setData] = useState("");
  const [response, setResponse] = useState("");
  
  const navigate = useNavigate();
  

  const handleChange = (e) => {
    setCode(e.target.value);
    setError("");
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate OTP length
    if (code.length !== 6) {
      setError("OTP must be 6 digits.");
      return;
    }
    //navigate("/ChangePassword"); // Route to ChangePassword

    try {
      let response, data;
    if (user.newMember) { // New Member
      ({ response, data } = await verifyNewMemberOTP(code, email));
      console.log("validate OTP for new member :", data, response);
    } else {
      ({ response, data } = await verifyOTP(code, email));
    console.log("validate OTP for existing member:", data, response);
    }



    //  const data = await response.json();
    //  console.log("Token OTP :", data.accessToken);
    //  console.log("validate OTP :", data, response);


      if (response.ok) {
        console.log("Inside 200 response OTP :", data.accessToken);
        signIn(data.accessToken); // Store the JWT token in the context
        updateUser("newMember", false); // Set NewMember to false
        setSuccess("OTP validated successfully!");
        navigate("/ChangePassword"); // Route to ChangePassword

      } else {
        setError(data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }

  };

  return (
    <>
    <Box
          minHeight="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor="#f9f9f9"
        >
    <Box
      sx={{
        maxWidth: 400,
        margin: "auto",
        padding: 3,
        border: "1px solid #ddd",
        borderRadius: 2,
        boxShadow: 2,
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 500 }}>
          <Typography variant="body2" align="left" gutterBottom>
              Please check your email <b>{email}</b> and enter your 6 digits code (OTP). In case if you did not receive, please check spam folder or contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
              
          </Typography>
      </Box>
      <div><br /></div>

      <Typography variant="h5" sx={{ mb: 2, textAlign: "center" }}>
        Enter OTP
      </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="OTP"
              variant="outlined"
              fullWidth
              value={code}
              onChange={handleChange}
              inputProps={{
                maxLength: 6,
              }}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
            >
              Validate OTP
            </Button>
          </Grid>

          {error && (
            <Grid item xs={12}>
              <Alert severity="error">{error}</Alert>
            </Grid>
          )}

          {success && (
            <Grid item xs={12}>
              <Alert severity="success">{success}</Alert>
            </Grid>
          )}
        </Grid>
      </form>
    </Box>
    </Box>
    </>
  );
};

export default ValidateOTP;
